/**
 * A club's badge, with its code as the fallback.
 *
 * One component because two screens now show one, and a badge that renders
 * differently on Manage Clubs and Manage Games would make the same club look
 * like two. It also puts the broken-image handling in one place: a logo_url
 * that 404s is common (a club whose badge moved) and must degrade to the code
 * rather than to a browser's broken-image glyph.
 */
import { useState } from 'react'

export function ClubLogo({ code, url, name, size = 'md' }: {
  code: string
  url?: string | null
  /** Used as the accessible name; the image itself is decorative beside it. */
  name?: string | null
  size?: 'sm' | 'md'
}) {
  const [broken, setBroken] = useState(false)
  const cls = `club-logo club-logo--${size}`

  if (!url || broken) {
    // Three characters, because that is what fits and what club codes are.
    return <span className={`${cls} club-logo--ph`} title={name ?? code}>
      {code.slice(0, 3)}
    </span>
  }
  return <img className={cls} src={url} alt="" title={name ?? code}
              onError={() => setBroken(true)} />
}

export default ClubLogo
